import { render, staticRenderFns } from "./ScoreLead.vue?vue&type=template&id=6453a98d"
import script from "./ScoreLead.vue?vue&type=script&lang=js"
export * from "./ScoreLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports